import security from "./security.svg";
import googleicon from "./googleicon.svg";
import twitter from "./twitter.svg";
import apple from "./apple.svg";
import trade from "./trade.png";
import tradeicon from "./tradeicon.png";
import dollerwhite from "./dollerwhite.png";
import todayloss from "./todayloss.png";
import toddayprofit from "./toddayprofit.png";
import totalloss from "./totalloss.png";
import dashboard from "./dashboard.png";
import dashboardblue from "./dashboard-blue.png";
import optionicon from "./option-icon.svg";
import optionblue from "./option-blue.svg";
import profitgrey from "./profit-grey.svg";
import profitwhite from "./profit-white.svg";
import closegrey from "./close-grey.svg";
import closewhite from "./close-white.svg";
import aiwhite from "./ai-white.svg";
import aigrey from "./ai-grey.svg";
import tradingicon from "./trading-icon.png";
import yahooicon from "./yahoo-icon.png";
import threedots from "./three-dots.svg";
import chatgpt from "./chat-gpt.svg";
import mitwhite from "./mit-white.svg";
import mitgrey from "./mit-grey.svg";
import parawhite from "./para-white.svg";
import paragrey from "./para-grey.svg";
import xai from "./xai.svg";
import downarrow from "./downarrow.svg";
import leftarrow from "./leftarrow.svg";
import graphgrey from "./graphgrey.svg";
import graphwhite from "./graphwhite.svg";
import shareicon from "./share-icon.svg";
import applewhite from "./apple-white.svg";

interface ImageType {
    security: string;
    googleicon: string;
    twitter: string;
    apple: string;
    trade: string;
    tradeicon: string;
    dollerwhite: string;
    todayloss: string;
    toddayprofit: string;
    totalloss: string;
    dashboard: string;
    dashboardblue: string;
    optionicon: string;
    optionblue: string;
    profitgrey: string;
    profitwhite: string;
    closegrey: string;
    closewhite: string;
    aiwhite: string;
    aigrey: string;
    tradingicon: string;
    yahooicon: string;
    threedots: string;
    chatgpt: string;
    mitwhite: string;
    mitgrey: string;
    parawhite: string;
    paragrey: string;
    xai: string;
    downarrow: string;
    leftarrow: string;
    graphwhite: string;
    graphgrey: string;
    shareicon: string;
    applewhite:string;
}
const Images: ImageType = {
    security: security,
    googleicon: googleicon,
    twitter: twitter,
    apple: apple,
    trade: trade,
    tradeicon: tradeicon,
    dollerwhite: dollerwhite,
    toddayprofit: toddayprofit,
    todayloss: todayloss,
    totalloss: totalloss,
    dashboard: dashboard,
    dashboardblue: dashboardblue,
    optionicon: optionicon,
    optionblue: optionblue,
    profitwhite: profitwhite,
    profitgrey: profitgrey,
    closegrey: closegrey,
    closewhite: closewhite,
    aiwhite: aiwhite,
    aigrey: aigrey,
    tradingicon: tradingicon,
    yahooicon: yahooicon,
    threedots: threedots,
    chatgpt: chatgpt,
    mitwhite: mitwhite,
    mitgrey: mitgrey,
    parawhite: parawhite,
    paragrey: paragrey,
    xai: xai,
    downarrow: downarrow,
    leftarrow: leftarrow,
    graphwhite: graphwhite,
    graphgrey: graphgrey,
    shareicon: shareicon,
    applewhite:applewhite
}
export default Images